import { useAccountCreateQry } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'
import { useContext } from 'react'
import './AccountCreateModal.scss'

interface Props {
  filteredCurrencies?: string[]
  onSuccess: (currencyCode: string, accountId: number) => void
}

function AccountCreateModal({ filteredCurrencies, onSuccess }: Props) {
  const { modalHide } = useContext(GlobalContext)

  const { currencies, formValues, createAccountError, createAccountFetching, handleSubmit } = useAccountCreateQry({
    filteredCurrencies,
    onSuccess
  })

  return (
    <div className='account-create-wrapper' data-test='create-account-modal'>
      <div className='account-create-title'>{tr('PORTAL.ACCOUNTS.CREATE.TITLE', 'Add new account')}</div>

      <form className='account-create-form' noValidate>
        <Input
          type='select'
          data-test='currency'
          label={tr('PORTAL.ACCOUNTS.CREATE.CURRENCY', 'Currency')}
          options={currencies}
          onChange={(name: string, value: string) => formValues.setValue(name, value)}
          {...formValues.registerShort('currency')}
          menuPosition='fixed'
        />

        <Input
          type='text'
          data-test='account-name'
          label={tr('PORTAL.ACCOUNTS.CREATE.NAME', 'Account name')}
          {...formValues.registerInput('name')}
        />

        <ErrorDisplay error={createAccountError} />

        <div className='account-create-buttons'>
          <Button
            type='button'
            color='primary'
            text={tr('PORTAL.ACCOUNTS.CREATE.SUBMIT_BUTTON', 'Add')}
            loading={createAccountFetching}
            data-test='button-submit'
            onClick={handleSubmit}
          />

          <Button
            type='button'
            color='secondary'
            text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            disabled={createAccountFetching}
            data-test='button-cancel'
            onClick={modalHide}
          />
        </div>
      </form>
    </div>
  )
}

export default AccountCreateModal
